export const siteInfo = {
  name: '女神漫画',
  title: '女神漫画：下拉式弹窗翻页阅读体验，免费全集漫画在线阅读，韩漫日漫国漫推荐，热门收藏追更大全集',
  description: '女神漫画支持下拉式、弹窗、翻页等多种阅读模式，提供免费全集漫画在线阅读，涵盖韩漫、日漫、国漫推荐，并支持收藏追更热门漫画。',
  keywords: '女神漫画,下拉式阅读,弹窗阅读,翻页阅读,免费全集,漫画在线阅读,韩漫,日漫,国漫,收藏,追更,漫画大全',
  slogan: '你的随身漫画图书馆，随时随地畅读热门全集',
  heroIntro: '女神漫画是一个专注高品质漫画阅读的在线平台，覆盖韩漫、日漫、国漫三大品类，每日更新热门连载与经典全集。我们提供下拉式、弹窗与翻页三种阅读模式，适配不同场景下的浏览习惯，让你在手机或电脑上都能获得沉浸式的漫画阅读体验。无论你是追更党还是补番控，这里都有你想要的下一部心头好。',
};

export const updatesData = [
  {
    date: '2026.07.28',
    tag: '新番上架',
    title: '《霸总的天价新娘》第三季正式上线，全集一次性放出',
    desc: '热门韩漫续作重磅回归，女主逆袭剧情再升级，首日阅读量突破 80 万。',
  },
  {
    date: '2026.07.27',
    tag: '完结公告',
    title: '《斗罗大陆》番外篇今日完结，全系列可一口气读完',
    desc: '历时三年连载画上句号，新增 12 话番外内容已全部入库，收藏用户可前往书架查看。',
  },
  {
    date: '2026.07.26',
    tag: '功能更新',
    title: '弹窗阅读模式新增双击放大与手势翻页支持',
    desc: '移动端体验全面优化，弹窗模式现在支持双击局部放大和左右滑动手势，追漫更顺手。',
  },
  {
    date: '2026.07.25',
    tag: '榜单揭晓',
    title: '七月人气榜出炉：《女神降临》连续第三个月霸榜',
    desc: '本月 Top 10 中韩漫占据六席，校园恋爱与职场逆袭题材持续走高。',
  },
  {
    date: '2026.07.24',
    tag: '专题推荐',
    title: '「夏日纳凉特辑」上线：精选 20 部悬疑恐怖类漫画',
    desc: '炎炎夏日来点后背发凉的阅读体验，恐怖漫画专区已更新，胆子大的来挑战。',
  },
  {
    date: '2026.07.23',
    tag: '合作联动',
    title: '与快看漫画达成内容互推合作，新增 50+ 部独家作品',
    desc: '即日起可在女神漫画直接阅读快看平台热门作品，无需跳转，阅读记录自动同步。',
  },
  {
    date: '2026.07.22',
    tag: '活动预告',
    title: '「追更打卡」暑期活动即将开启，连续签到赢限定头像框',
    desc: '7 月 30 日起，连续追更打卡 7 天即可获得限定头像框和阅读时长加倍券。',
  },
];

export const aboutData = {
  title: '关于女神漫画',
  paragraphs: [
    '女神漫画诞生于 2019 年，由一群热爱漫画文化的开发者和编辑共同创立。我们致力于打造一个专注漫画阅读体验的平台，让每一位漫画爱好者都能在流畅、舒适的界面中发现和享受好故事。',
    '平台目前覆盖韩漫、日漫、国漫三大核心品类，收录超过 3,000 部作品，涵盖恋爱、奇幻、悬疑、热血、搞笑、日常等全类型题材。所有漫画均支持下拉式、弹窗和翻页三种阅读模式，你可以根据场景自由切换——通勤路上用下拉式一滑到底，深夜躺床用弹窗模式单手操作，大屏看漫用翻页模式还原纸质阅读感。',
    '我们坚持每日更新热门连载，同时持续扩充经典全集资源。收藏功能让你不错过任何一部追更作品的更新提醒，书签和历史记录则帮助你随时回到上次读到的地方。女神漫画，不只是一个阅读工具，更是一个漫画爱好者的精神角落。',
  ],
};

export const faqData = [
  {
    q: '女神漫画是免费的吗？需要付费订阅吗？',
    a: '女神漫画目前所有内容均为免费阅读，无需付费订阅。我们通过广告合作维持平台运营，不会向用户收取任何阅读费用。未来如果推出增值服务，也会保持基础阅读的免费策略不变。',
  },
  {
    q: '下拉式、弹窗和翻页三种阅读模式有什么区别？如何切换？',
    a: '下拉式模式适合手机竖屏单手滑动阅读，页面连续向下延伸；弹窗模式将每一话内容放入可拖拽的浮窗中，适合多任务场景；翻页模式模拟纸质漫画的左右翻页效果，适合横屏和大屏设备。在阅读界面点击顶部工具栏的模式切换按钮即可自由切换。',
  },
  {
    q: '如何收藏漫画和查看更新提醒？',
    a: '在漫画详情页点击"收藏"按钮即可将作品加入你的书架。已收藏的作品在更新新章节时，书架入口会出现红点提醒，你也可以在设置中开启推送通知，第一时间获取更新动态。',
  },
  {
    q: '支持离线下载阅读吗？',
    a: '目前女神漫画暂不支持离线下载功能。考虑到版权保护和内容安全，我们建议在 Wi-Fi 或移动网络环境下在线阅读。离线下载功能正在开发中，预计今年第四季度上线，届时会通过站内公告通知大家。',
  },
  {
    q: '漫画加载慢或显示异常怎么办？',
    a: '首先建议检查网络连接，切换 Wi-Fi 或移动数据尝试。如果问题仍然存在，可以尝试清除浏览器缓存或更新 App 到最新版本。在阅读界面可以手动调整图片清晰度，标清模式下加载速度更快。如仍有问题，可以通过"联系我们"页面提交反馈。',
  },
  {
    q: '我可以在其他平台分享女神漫画的内容吗？',
    a: '欢迎在社交媒体分享你喜欢的漫画作品和阅读体验！每部漫画详情页都提供了分享按钮，支持一键分享到微信、微博、QQ 等平台。但请注意，未经授权不得批量转载漫画原图或商业使用，请尊重原创作者的版权。',
  },
];

export const appData = {
  title: '女神漫画 · 移动端',
  subtitle: '随时随地，尽享漫画世界',
  description: '女神漫画移动端完美适配手机与平板，自动识别屏幕尺寸提供最佳阅读布局。下拉式阅读专为单手操作优化，弹窗模式让你边聊微信边看漫画。无需安装，浏览器打开即用，添加到桌面即可像原生 App 一样流畅运行。',
  features: ['免安装即用', '单手阅读优化', '自动适配屏幕', '低流量模式', '夜间模式护眼'],
};

export const carouselData = [
  {
    title: '韩漫 · 恋爱物语',
    subtitle: '从校园到职场，甜蜜永不散场',
    desc: '精选 50+ 部高甜恋爱韩漫，每一帧都是壁纸级画风。从《女神降临》到《社内相亲》，颜值与剧情双在线。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20webtoon%20illustration%20featuring%20a%20couple%20walking%20hand%20in%20hand%20under%20cherry%20blossoms%20at%20sunset%2C%20soft%20pastel%20tones%2C%20dreamy%20atmosphere%2C%20anime%20art%20style%2C%20clean%20composition%2C%20editorial%20manga%20cover%20aesthetic%2C%20warm%20golden%20light%20filtering%20through%20petals&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '日漫 · 经典殿堂',
    subtitle: '从小看到大的名作，一部不落',
    desc: '收录《海贼王》《咒术回战》《间谍过家家》等经典日漫全集，从连载到完结，陪你走过每一个漫画时代。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20an%20epic%20adventure%20scene%20with%20a%20young%20hero%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20fantasy%20world%2C%20dramatic%20clouds%2C%20vibrant%20sunset%20colors%2C%20shounen%20art%20style%2C%20dynamic%20composition%2C%20high%20detail%20anime%20illustration&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '国漫 · 崛起力量',
    subtitle: '东方美学，燃爆视觉神经',
    desc: '《斗罗大陆》《一人之下》《狐妖小红娘》……国漫精品一网打尽，每一部都是国产漫画的骄傲。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20martial%20arts%20warrior%20in%20flowing%20traditional%20robes%20standing%20among%20ancient%20temple%20ruins%2C%20ink%20wash%20painting%20aesthetic%20blended%20with%20modern%20anime%20style%2C%20mystical%20energy%20swirls%2C%20ethereal%20lighting%2C%20dramatic%20pose&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '悬疑 · 烧脑专区',
    subtitle: '每一话都让人脊背发凉',
    desc: '从推理到恐怖，从心理到超自然，悬疑漫画专区汇集最令人窒息的精彩故事，胆子大的点进来。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20thriller%20manga%20style%20illustration%20with%20a%20lone%20figure%20standing%20in%20a%20dimly%20lit%20alleyway%20under%20a%20single%20flickering%20streetlamp%2C%20deep%20shadows%2C%20noir%20atmosphere%2C%20rain-slicked%20pavement%20reflecting%20neon%20signs%2C%20intense%20moody%20composition%2C%20high%20contrast%20monochromatic%20with%20subtle%20red%20accents&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '奇幻 · 异世界冒险',
    subtitle: '开启属于你的第二人生',
    desc: '重生、穿越、异世界转生——奇幻漫画带你逃离日常，在平行宇宙中书写属于自己的传奇故事。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20manga%20illustration%20of%20a%20magical%20floating%20city%20with%20crystalline%20towers%20above%20clouds%2C%20airships%20sailing%20between%20spires%2C%20vibrant%20sunset%20sky%20with%20multiple%20moons%2C%20epic%20scale%20scenery%2C%20studio%20ghibli%20inspired%20aesthetic%2C%20warm%20golden%20and%20teal%20color%20palette&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
  {
    title: '热血 · 战斗不息',
    subtitle: '点燃你心中的那团火',
    desc: '战斗、成长、友情——热血漫画的三大要素在这里被演绎到极致，每一场对决都让人肾上腺素飙升。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20manga%20illustration%20of%20two%20warriors%20clashing%20mid-air%20with%20energy%20bursts%20radiating%20outward%2C%20powerful%20impact%20effects%2C%20speed%20lines%2C%20dramatic%20perspective%20from%20below%2C%20intense%20warm%20orange%20and%20crimson%20color%20scheme%2C%20shounen%20battle%20style%2C%20explosive%20composition&width=800&height=500&seq=carousel-06&orientation=landscape',
  },
];

export const indexData = [
  { title: '恋爱漫画', count: '856 部', icon: 'ri-heart-line', desc: '甜蜜恋爱、虐心虐恋，总有一款戳中你' },
  { title: '奇幻冒险', count: '623 部', icon: 'ri-compass-3-line', desc: '异世界转生、魔法奇幻，冒险永不停歇' },
  { title: '热血战斗', count: '541 部', icon: 'ri-fire-line', desc: '燃到爆的战斗场面，热血沸腾的成长故事' },
  { title: '悬疑推理', count: '389 部', icon: 'ri-search-eye-line', desc: '层层反转，烧脑推理，真相只有一个' },
  { title: '搞笑日常', count: '472 部', icon: 'ri-emotion-laugh-line', desc: '轻松解压的日常搞笑，笑到停不下来' },
  { title: '都市情感', count: '618 部', icon: 'ri-building-line', desc: '职场爱情、都市生活，贴近现实的精彩故事' },
  { title: '古风国漫', count: '305 部', icon: 'ri-brush-line', desc: '水墨丹青、古韵悠长，东方美学的极致呈现' },
  { title: '恐怖惊悚', count: '198 部', icon: 'ri-ghost-line', desc: '深夜慎入，挑战你的心理极限' },
];

export const contactData = {
  title: '联系我们',
  subtitle: '无论是投稿建议、商务合作还是使用反馈，我们都在这里等你',
  sections: [
    { icon: 'ri-mail-line', title: '投稿与合作', desc: '原创作者投稿或商务合作洽谈，请发送至投稿邮箱' },
    { icon: 'ri-bug-line', title: '问题反馈', desc: '遇到阅读问题或功能建议，我们会在 24 小时内回复处理' },
    { icon: 'ri-team-line', title: '加入我们', desc: '热爱漫画文化？女神漫画团队持续招募编辑与开发人才' },
  ],
};

export const commentsData = [
  {
    name: '漫画少女小樱',
    avatar: 'A',
    time: '2 小时前',
    content: '女神漫画的阅读体验真的太棒了！特别是下拉式模式，单手就能轻松追漫，通勤路上必备。韩漫资源也很全，追的几部冷门作品居然都有。',
    likes: 1283,
  },
  {
    name: '深夜追更人',
    avatar: '深',
    time: '5 小时前',
    content: '弹窗模式简直是多任务神器！一边写论文一边追《霸总的天价新娘》，摸鱼体验满分。希望后续能增加更多国漫资源，最近国漫质量太高了。',
    likes: 967,
  },
  {
    name: '日漫死忠粉',
    avatar: '日',
    time: '昨天',
    content: '从贴吧时代就开始看漫画，女神漫画是我用过最舒服的在线漫画平台。翻页模式还原了纸质阅读的感觉，加载速度也很快，给开发团队点赞！',
    likes: 845,
  },
  {
    name: '柠檬不酸',
    avatar: '柠',
    time: '昨天',
    content: '收藏功能很好用，追的十几部漫画更新了都会有提醒，再也不用每天手动刷新了。要是能出个 iPad 横屏优化版就更好了，大屏看日漫翻页模式超爽。',
    likes: 623,
  },
  {
    name: '画手小新',
    avatar: '画',
    time: '前天',
    content: '作为一个漫画创作者，女神的阅读体验给了我很多灵感。画面清晰度很高，不会像某些平台那样压缩得看不清细节。希望以后能开放原创投稿入口！',
    likes: 512,
  },
];

export const rankingData = [
  { rank: 1, title: '女神降临', category: '韩漫 · 恋爱', heat: '128.6 万', change: 'up', episodes: '连载至 186 话' },
  { rank: 2, title: '社内相亲', category: '韩漫 · 职场', heat: '115.3 万', change: 'up', episodes: '已完结 142 话' },
  { rank: 3, title: '斗罗大陆', category: '国漫 · 热血', heat: '98.7 万', change: 'same', episodes: '连载至 358 话' },
  { rank: 4, title: '咒术回战', category: '日漫 · 战斗', heat: '87.2 万', change: 'up', episodes: '连载至 263 话' },
  { rank: 5, title: '某天成为公主', category: '韩漫 · 奇幻', heat: '76.9 万', change: 'down', episodes: '已完结 125 话' },
];

export const topicsData = [
  { tag: '#韩漫推荐', heat: '236 万讨论' },
  { tag: '#女神降临', heat: '189 万讨论' },
  { tag: '#今日更新', heat: '156 万讨论' },
  { tag: '#下拉式阅读', heat: '134 万讨论' },
  { tag: '#恋爱漫画', heat: '122 万讨论' },
  { tag: '#国漫崛起', heat: '108 万讨论' },
  { tag: '#漫画安利', heat: '95 万讨论' },
  { tag: '#周末补番', heat: '87 万讨论' },
  { tag: '#弹窗阅读', heat: '73 万讨论' },
  { tag: '#日漫经典', heat: '68 万讨论' },
];

export const mediaData = [
  {
    title: '《女神降临》动画 PV 首发',
    desc: '人气韩漫改编动画预告公开，画风还原度极高，粉丝狂喜',
    duration: '02:34',
    views: '128 万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20PV%20screenshot%20of%20Goddess%20Advent%20Korean%20webtoon%20adaptation%2C%20beautiful%20female%20protagonist%20in%20school%20uniform%20under%20cherry%20blossom%20tree%2C%20soft%20lighting%2C%20high%20quality%20animation%20still%2C%20pastel%20color%20palette%2C%20dreamy%20atmosphere%2C%20close-up%20portrait%20composition&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '七月新番速递：10 部必看漫画推荐',
    desc: '编辑部精选本月最值得入坑的新连载，覆盖恋爱、奇幻、热血三大赛道',
    duration: '08:15',
    views: '96 万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20recommendation%20collage%20illustration%20showing%20various%20manga%20covers%20arranged%20artistically%2C%20colorful%20anime%20art%20styles%20mixed%20together%2C%20vibrant%20composition%20with%20warm%20summer%20tones%2C%20editorial%20layout%2C%20Japanese%20magazine%20aesthetic%2C%20creative%20arrangement%20of%20comic%20panels&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '中国漫画家专访：从爱好者到职业创作',
    desc: '对话三位当红国漫作者，聊聊创作背后的故事与行业现状',
    duration: '15:42',
    views: '73 万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Art%20studio%20interior%20with%20drawing%20tablet%20and%20manga%20sketches%20on%20desk%2C%20warm%20afternoon%20sunlight%20streaming%20through%20window%2C%20creative%20workspace%20atmosphere%2C%20ink%20brushes%20and%20reference%20books%20scattered%2C%20cozy%20artistic%20environment%2C%20soft%20natural%20lighting%2C%20documentary%20style&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '漫画阅读 App 横评：谁才是追漫神器？',
    desc: '我们从界面、加载速度、资源量和阅读模式四个维度横向对比主流漫画平台',
    duration: '12:08',
    views: '58 万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20comic%20reading%20on%20tablet%20device%20with%20manga%20page%20displayed%20beautifully%2C%20cozy%20reading%20nook%20with%20warm%20ambient%20lighting%2C%20modern%20minimalist%20setup%2C%20late%20night%20reading%20atmosphere%2C%20soft%20warm%20glow%20from%20screen%2C%20lifestyle%20photography%20aesthetic%2C%20clean%20and%20inviting%20composition&width=800&height=500&seq=media-04&orientation=landscape',
  },
];

export const cardsData = [
  {
    title: '《霸总的天价新娘》第三季',
    category: '韩漫 · 恋爱',
    tag: '新番',
    desc: '女主重生逆袭，霸总追妻火葬场，第三季剧情全面升级，甜度与虐度同时拉满。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20webtoon%20illustration%20of%20a%20confident%20businesswoman%20in%20a%20modern%20office%20with%20floor-to-ceiling%20windows%20overlooking%20city%20skyline%20at%20sunset%2C%20sophisticated%20fashion%20style%2C%20warm%20amber%20and%20rose%20gold%20tones%2C%20romance%20manga%20cover%20aesthetic%2C%20portrait%20composition%20with%20soft%20bokeh%20background&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    title: '《斗罗大陆》番外篇合集',
    category: '国漫 · 热血',
    tag: '完结',
    desc: '唐三与小舞的婚后日常、史莱克七怪番外故事，12 话全新内容一次放出。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fantasy%20illustration%20of%20a%20heroic%20couple%20in%20traditional%20cultivation%20style%20robes%20standing%20on%20a%20mountain%20peak%20with%20glowing%20spirit%20rings%2C%20celestial%20energy%20swirling%20around%2C%20epic%20sunrise%20landscape%2C%20ink%20wash%20and%20digital%20art%20fusion%2C%20majestic%20composition%2C%20warm%20gold%20and%20jade%20green%20tones&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    title: '《咒术回战》涩谷事变篇',
    category: '日漫 · 战斗',
    tag: '热更',
    desc: '涩谷事变篇全程高能，五条悟封禁、宿傩降临，每一话都让人看得停不下来。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20Japanese%20manga%20action%20scene%20with%20a%20powerful%20sorcerer%20casting%20devastating%20technique%20in%20urban%20Tokyo%20at%20night%2C%20dynamic%20energy%20effects%2C%20neon%20lights%20contrasting%20with%20dark%20shadows%2C%20dramatic%20perspective%2C%20shounen%20jump%20style%20illustration%2C%20high%20contrast%20with%20deep%20crimson%20and%20electric%20blue%20accents&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    title: '《我养的狼崽子》逆袭路',
    category: '韩漫 · 奇幻',
    tag: '推荐',
    desc: '养了一只小狼狗，长大后居然是魔族王子？奇幻恋爱喜剧，画风精美到每一帧都能做壁纸。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fantasy%20romance%20Korean%20webtoon%20art%20with%20elegant%20silver-haired%20male%20character%20and%20female%20protagonist%20in%20a%20magical%20garden%20with%20glowing%20flowers%20under%20moonlight%2C%20romantic%20atmosphere%2C%20ornate%20fantasy%20costumes%2C%20soft%20ethereal%20lighting%2C%20dreamy%20purple%20and%20silver%20color%20palette%2C%20romantic%20couple%20composition&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    title: '《一人之下》异人世界',
    category: '国漫 · 奇幻',
    tag: '经典',
    desc: '中国最成功的异能战斗漫画之一，从罗天大醮到唐门篇，世界观层层展开令人着迷。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manhua%20illustration%20of%20martial%20artists%20with%20elemental%20powers%20battling%20in%20an%20ancient%20Taoist%20temple%20courtyard%2C%20dynamic%20action%20poses%2C%20traditional%20Chinese%20architecture%2C%20swirling%20wind%20and%20fire%20effects%2C%20ink%20wash%20style%20mixed%20with%20modern%20digital%20art%2C%20dramatic%20composition%2C%20vermillion%20and%20ink%20black%20color%20scheme&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    title: '《社内相亲》全集重温',
    category: '韩漫 · 职场',
    tag: '完结',
    desc: '假扮女友去相亲，结果对象是公司社长？已完结全集 142 话，一口气看到结局。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20Korean%20webtoon%20illustration%20of%20a%20couple%20having%20an%20awkward%20but%20sweet%20dinner%20date%20at%20an%20upscale%20restaurant%2C%20warm%20ambient%20lighting%20from%20chandeliers%2C%20city%20night%20view%20through%20windows%2C%20elegant%20atmosphere%2C%20soft%20focus%20background%2C%20charming%20and%20heartwarming%20composition%2C%20cream%20and%20rose%20gold%20tones&width=800&height=500&seq=card-06&orientation=landscape',
  },
  {
    title: '《狐妖小红娘》月红篇',
    category: '国漫 · 恋爱',
    tag: '推荐',
    desc: '跨越千年的爱恋，红红与月初的凄美故事。国漫恋爱题材的巅峰之作，每一帧都美如画。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20manhua%20illustration%20of%20fox%20spirit%20couple%20in%20ancient%20Chinese%20setting%2C%20magical%20glowing%20fox%20ears%20and%20tails%2C%20traditional%20red%20wedding%20attire%2C%20floating%20lanterns%20at%20night%2C%20enchanting%20atmosphere%2C%20poetic%20oriental%20aesthetic%2C%20vermillion%20and%20gold%20color%20palette%2C%20ethereal%20and%20majestic%20composition&width=800&height=500&seq=card-07&orientation=landscape',
  },
];

export const featuresData = [
  {
    icon: 'ri-file-list-3-line',
    title: '三种阅读模式',
    desc: '下拉式、弹窗、翻页自由切换，适配手机单手操作、多任务同屏和大屏沉浸阅读，总有一种适合你的追漫姿势。',
  },
  {
    icon: 'ri-global-line',
    title: '三大漫画品类',
    desc: '韩漫、日漫、国漫全覆盖，从热门连载到冷门佳作，超过 3,000 部作品持续扩充，你的下一部心头好就藏在这里。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '智能收藏追更',
    desc: '一键收藏心仪作品，更新自动提醒。书架支持分类整理和阅读进度追踪，再也不会忘记追到哪里了。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载体验',
    desc: '自研图片压缩与预加载技术，4G 网络下也能秒开漫画。支持标清/高清自由切换，流量党也能放心追。',
  },
  {
    icon: 'ri-moon-line',
    title: '夜间模式护眼',
    desc: '深夜追漫党的福音。自适应夜间模式降低屏幕蓝光，配合柔和背景色，熬夜看漫画也不伤眼。',
  },
];

export const footerData = {
  intro: '女神漫画是一个专注高品质漫画阅读的在线平台，提供下拉式、弹窗、翻页三种阅读模式，覆盖韩漫、日漫、国漫全品类。每日更新热门连载与经典全集，支持收藏追更，致力于为漫画爱好者打造最舒适的在线阅读体验。',
  links: [
    { title: '快速导航', items: ['首页', '最新更新', '热门排行', '分类浏览'] },
    { title: '帮助支持', items: ['常见问题', '阅读指南', '联系我们', '意见反馈'] },
    { title: '关于我们', items: ['平台介绍', '加入团队', '商务合作', '用户协议'] },
  ],
};